var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 10.5C1 5.25332 5.25332 1 10.5 1C15.7467 1 20 5.25332 20 10.5C20 12.7632 19.2086 14.8415 17.8875 16.4733L21.5605 20.1464C21.9511 20.5369 21.9511 21.1701 21.5605 21.5606C21.17 21.9511 20.5368 21.9511 20.1463 21.5606L16.4733 17.8876C14.8414 19.2086 12.7631 20 10.5 20C5.25332 20 1 15.7467 1 10.5ZM10.5 3C6.35788 3 3 6.35788 3 10.5C3 14.6421 6.35788 18 10.5 18C14.6421 18 18 14.6421 18 10.5C18 6.35788 14.6421 3 10.5 3ZM6.96452 6.46444C7.86825 5.56072 9.11962 5 10.5 5C11.8805 5 13.1319 5.56071 14.0356 6.46444C14.4261 6.85497 14.4261 7.48813 14.0356 7.87866C13.6451 8.26918 13.0119 8.26918 12.6214 7.87866C12.0774 7.33469 11.3288 7 10.5 7C9.67134 7 8.92271 7.33468 8.37874 7.87866C7.98821 8.26918 7.35505 8.26918 6.96452 7.87866C6.574 7.48813 6.574 6.85497 6.96452 6.46444Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchOutline);
export default __webpack_public_path__ + "static/media/search-outline.8022bc252feab42f48c9a0e0037eb3a0.svg";
export { ForwardRef as ReactComponent };